import styled from 'styled-components';

export const ApplicationContentStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;

export const CenteredApplicationContent = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.caps.big}px;
  margin-inline: auto;
  min-width: 0;
`;

export const ClientSingleApplicationPageV2Actions = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => `${theme.spacing.sm}px 12px 0 0`};
  min-height: 24px;
`;

export const ClientSingleApplicationPageV2Content = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 10px;
`;
